import React from 'react'
import Blog from '../Blog/Blog'

export default function Resources() {
  return (
    <>
    <Blog/>
    </>
  )
}
